var _linearGradient, _path, _linearGradient2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadToCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256.094,
    x2: 256.094,
    y1: 283.511,
    y2: 54.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#FFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M424.281 191.029c-3.122 0-6.169.314-9.117.903-4.548-41.231-39.485-73.308-81.928-73.308a83.31 83.31 0 0 0-9.465.557C305.253 80.812 265.978 54.34 220.519 54.34c-58.568 0-106.867 43.943-113.74 100.657-.283-.004-.563-.021-.846-.021-35.493 0-64.267 28.773-64.267 64.268s28.773 64.268 64.267 64.268h318.349c25.538 0 46.241-20.702 46.241-46.241-.001-25.54-20.704-46.242-46.242-46.242z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 135.613,
    x2: 365.683,
    y1: 341.579,
    y2: 111.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7BAC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M451.551 185.248c-7.991-4.07-16.524-6.228-25.433-6.636a14.253 14.253 0 0 0-.92-.061c-4.803-19.221-14.894-36.79-30.427-49.721-17.979-14.967-40.472-23.105-63.724-22.569-20.52-36.046-57.875-59.875-99.302-63.877-41.533-4.013-83.985 14.091-109.983 46.677-12.821 16.069-21.169 34.236-25.417 53.963-32.049 3.987-60.167 29.574-65.774 61.808-6.473 37.209 14.092 73.704 49.702 86.739 12.51 4.579 25.313 4.44 38.333 4.44h297.976c18.306 0 35.66-3.63 49.235-17.205 27.286-27.286 20.477-75.862-14.266-93.558zm-1.75 74.12c-8.926 10.187-20.517 11.643-33.009 11.643H186.077c-26.299 0-52.6.093-78.898 0-21.242-.075-40.939-11.963-49.179-31.956-10.76-26.104 2.134-56.953 28.146-67.745 6.496-2.695 13.615-3.989 20.632-3.813 7.381.186 11.652-5.93 12.5-12.5 4.266-33.087 25.852-62.161 55.292-77.276 31.094-15.964 69.389-14.049 99.122 4.046 17.203 10.47 30.425 25.724 39.286 43.724 1.761 3.579 6.767 6.599 10.793 6.191 19.12-1.937 38.223 2.529 53.322 14.827 13.751 11.199 23.43 27.713 25.57 45.424 1.036 8.571 7.114 13.576 15.823 12.053 1.938-.339 3.821-.407 5.794-.457 28.015.515 44.535 34.14 25.521 55.839z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F5EAB",
    d: "M359.786 342.305 256.094 198.288 152.402 342.305h61.355v127.864h84.675V342.305z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadToCloud);
export default __webpack_public_path__ + "static/media/upload-to-cloud.5c949775791f947fe23ad736fc320198.svg";
export { ForwardRef as ReactComponent };